import FeeScheduleCategoryCommand from "marketplace/teams/fee-schedules/_api/commands/fee-schedule-category-command";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";

export default class FeeScheduleTemplateCommand {
  entityId: string;
  name: string;
  tags: string[] = [];
  categories: FeeScheduleCategoryCommand[] = [];
  creatorType?: string;

  constructor(template: FeeScheduleTemplate, creatorType: string = 'client') {
    if (!template.creator?.legalEntityId)
      throw new Error(
        "Template must indicate entity fee schedule is being created for."
      );
    this.entityId = template.creator.legalEntityId.value;
    this.name = template.name;
    this.tags = template.tags.map((tag) => tag.value);
    this.categories = template.categories.map(
      (category) => new FeeScheduleCategoryCommand(category)
    );
    this.creatorType = creatorType;
  }
}
